(function () {
  'use strict';

  function initSection(section) {
    if (!('IntersectionObserver' in window)) {
      section.classList.add('wwa-in-view');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('wwa-in-view');
            observer.unobserve(section);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(section);
  }

  function init() {
    document.querySelectorAll('.wwa-animate').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.wwa-animate');
    if (section) initSection(section);
  });
})();
